module.exports = __webpack_public_path__ + "static/img/approve-icon.5b4d34fb.svg";